import { Alert } from "./Alert";
import "./alert.css";

export default Alert;
